import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates a succesful login request.
 */
export class OnRequestCommandBody implements CommandBody {}
